import CreateAcct from './createAcct.PNG';
import PatientStats from './patientStats.PNG';
import Logo from './logo.png';
import OncMap from './oncMap.PNG';
import MainMenu from './mainMenu.PNG';
import LookUp from './lookUp.PNG';
import DrawerNav from './drawerNav.PNG';
import SignIn from './signIn.PNG';

export {
  PatientStats, CreateAcct, Logo, OncMap, MainMenu, LookUp, DrawerNav, SignIn
}


// WEBPACK FOOTER //
// ./src/docs/assets/index.js